import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/List/List'
import WebComponent from '../../../WebComponent.js'
import I18n from "../../../i18n";
import BaseService from "../../../BaseService";
import AuditlogColumns from "./AuditlogColumns";

export default class Auditlog extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'auditlog-reload-triggered'
    }
  }

  constructor() {
    super()
    this.auditlogService = new BaseService('admin/auditlog')
    this.sigmoidColumns = [];
    this.kapaTechnischColumns = [];
    this.kapaGebuchtColumns = [];
    this.angebotColumns = [];
    this.kundensegmentierungColumns = [];
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/Auditlog/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this._refresh = () => {
      this.loadData();
      send(Auditlog.EVENT_KEYS.RELOAD_TRIGGERED);
    };

    this.sigmoidColumns = [
      AuditlogColumns.FIELD_NAME_COLUMN(),
      AuditlogColumns.BILANZ_ZONE_COLUMN(),
      AuditlogColumns.OLD_VALUE_COLUMN(),
      AuditlogColumns.NEW_VALUE_COLUMN(),
      AuditlogColumns.CHANGE_USER_COLUMN(),
      AuditlogColumns.CHANGE_DATE_COLUMN()
    ]

    this.kapaTechnischColumns = [
      AuditlogColumns.FIELD_NAME_COLUMN(),
      AuditlogColumns.EINSPEISEPUNKT_COLUMN(),
      AuditlogColumns.OLD_VALUE_COLUMN(),
      AuditlogColumns.NEW_VALUE_COLUMN(),
      AuditlogColumns.CHANGE_USER_COLUMN(),
      AuditlogColumns.CHANGE_DATE_COLUMN()
    ]

    this.kapaGebuchtColumns = [
      AuditlogColumns.FIELD_NAME_COLUMN(),
      AuditlogColumns.MONAT_COLUMN(),
      AuditlogColumns.OLD_VALUE_COLUMN(),
      AuditlogColumns.NEW_VALUE_COLUMN(),
      AuditlogColumns.CHANGE_USER_COLUMN(),
      AuditlogColumns.CHANGE_DATE_COLUMN()
    ]

    this.angebotColumns = [
      AuditlogColumns.FIELD_NAME_COLUMN(),
      AuditlogColumns.BILANZ_ZONE_COLUMN(),
      AuditlogColumns.DATE_COLUMN(),
      AuditlogColumns.OLD_VALUE_COLUMN(),
      AuditlogColumns.NEW_VALUE_COLUMN(),
      AuditlogColumns.CHANGE_USER_COLUMN(),
      AuditlogColumns.CHANGE_DATE_COLUMN()
    ]

    this.kundensegmentierungColumns = [
      AuditlogColumns.FIELD_NAME_COLUMN(),
      AuditlogColumns.BILANZ_ZONE_COLUMN(),
      AuditlogColumns.OLD_VALUE_COLUMN(),
      AuditlogColumns.NEW_VALUE_COLUMN(),
      AuditlogColumns.CHANGE_USER_COLUMN(),
      AuditlogColumns.CHANGE_DATE_COLUMN()
    ]

    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.removeEventListener(Auditlog.EVENT_KEYS.RELOAD_TRIGGERED, this._refresh);

    this.auditlogService.getBackendListUrl()
      .then(url => {
        this.url = url;
        this.loadData();
      })
      .catch(_ => {
        this.render();
      })
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.removeEventListener(Auditlog.EVENT_KEYS.RELOAD_TRIGGERED, this._refresh);
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.title')}"
                    size="large">
      </isceco-title>
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.sigmoid.title')}"
                    size="medium">
      </isceco-title>
      <isceco-list
        id="sigmoid-history"
        max="5"
        .i18n="${this.i18n}"
        .columns="${this.sigmoidColumns}"
        url="${this.url.concat('/').concat('sigmoid')}"
        update-event="${Auditlog.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.kapazitaet.technisch.title')}"
                    size="medium">
      </isceco-title>
      <isceco-list
        id="kapazitaet_technisch-history"
        max="5"
        .i18n="${this.i18n}"
        .columns="${this.kapaTechnischColumns}"
        url="${this.url.concat('/').concat('kapazitaet/technisch')}"
        update-event="${Auditlog.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.kapazitaet.gebucht.title')}"
                    size="medium">
      </isceco-title>
      <isceco-list
        id="kapazitaet-gebucht-history"
        max="5"
        .i18n="${this.i18n}"
        .columns="${this.kapaGebuchtColumns}"
        url="${this.url.concat('/').concat('kapazitaet/gebucht')}"
        update-event="${Auditlog.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.angebot.title')}"
                    size="medium">
      </isceco-title>
      <isceco-list
        id="angebot-history"
        max="5"
        .i18n="${this.i18n}"
        .columns="${this.angebotColumns}"
        url="${this.url.concat('/').concat('angebot')}"
        update-event="${Auditlog.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.auditlog.kundensegmentierung.title')}"
                    size="medium">
      </isceco-title>
      <isceco-list
        id="kundensegmentierung-history"
        max="5"
        .i18n="${this.i18n}"
        .columns="${this.kundensegmentierungColumns}"
        url="${this.url.concat('/').concat('kundensegmentierung')}"
        update-event="${Auditlog.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
    `
  }
}
customElements.define('gasmonitoring-frontend-admin-audit', Auditlog)
